import { Tooltip, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useCargoPlanning } from "../CargoPlanningProvider";
import { useAppToken } from "../../../../theme/v6/useAppToken";

const CargoPlanningFileError = ({ documentId }: { documentId?: number }) => {
  const state = useCargoPlanning();
  const { t } = useTranslation("translations");
  const { token } = useAppToken();
  const document = state?.documents.find((item) => item.documentId === documentId);
  if (!document || !(document.uploadError || document.hasErrors || document.status === "error")) return null;
  return (
    <Tooltip title={t("error")}>
      <Typography.Text type="danger" style={{ marginInlineStart: token.marginXS }}>
        <ExclamationCircleOutlined aria-label={t("error")} />
      </Typography.Text>
    </Tooltip>
  );
};

export default CargoPlanningFileError;
